// @ts-nocheck
import { Web3Provider } from '@ethersproject/providers'
import { ALL_SUPPORTED_CHAIN_IDS } from 'constants/chains'
import { INFURA_NETWORK_URLS } from 'constants/infura'
import { InjectedConnector } from 'packages/injected-connector'
import { WalletConnectConnector } from 'packages/wallet-connector'

import getLibrary from '../utils/getLibrary'
import { NetworkConnector } from './NetworkConnector'

export const network = new NetworkConnector({
  urls: INFURA_NETWORK_URLS,
  defaultChainId: 1,
})

let networkLibrary: Web3Provider | undefined
export function getNetworkLibrary(): Web3Provider {
  return (networkLibrary = networkLibrary ?? getLibrary(network.provider))
}

export const injected = new InjectedConnector({
  supportedChainIds: ALL_SUPPORTED_CHAIN_IDS,
})


export const walletconnect = new WalletConnectConnector({
  projectId: "4350e4fa71cfcea02482a46695af4164",
  chains: ALL_SUPPORTED_CHAIN_IDS,
  showQrModal: true,
  rpcMap: INFURA_NETWORK_URLS,
  qrModalOptions: {
    themeVariables: {
      '--wcm-font-family': '"Inter custom", sans-serif',
      '--wcm-z-index': 1060,
    },
  }
})
